var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFlagSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 3.44772 5.44772 3 6 3H18C18.3744 3 18.7175 3.20917 18.889 3.54203C19.0604 3.87488 19.0316 4.27565 18.8142 4.58052L16.3763 8L18.8142 11.4195C19.0316 11.7244 19.0604 12.1251 18.889 12.458C18.7175 12.7908 18.3744 13 18 13H7V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V4Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagSolid);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01IDRDNSAzLjQ0NzcyIDUuNDQ3NzIgMyA2IDNIMThDMTguMzc0NCAzIDE4LjcxNzUgMy4yMDkxNyAxOC44ODkgMy41NDIwM0MxOS4wNjA0IDMuODc0ODggMTkuMDMxNiA0LjI3NTY1IDE4LjgxNDIgNC41ODA1MkwxNi4zNzYzIDhMMTguODE0MiAxMS40MTk1QzE5LjAzMTYgMTEuNzI0NCAxOS4wNjA0IDEyLjEyNTEgMTguODg5IDEyLjQ1OEMxOC43MTc1IDEyLjc5MDggMTguMzc0NCAxMyAxOCAxM0g3VjIwQzcgMjAuNTUyMyA2LjU1MjI4IDIxIDYgMjFDNS40NDc3MiAyMSA1IDIwLjU1MjMgNSAyMFY0WiIgZmlsbD0iIzA0MDQwNSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };